<form class="g-3 needs-validation" novalidate [formGroup]="formFields" (ngSubmit)="onSubmit()">
  <div class="row equine-quote-details-row">
    <div class="col-md-8 equine-form-content">
      <!-- Quote Details Section -->
      <div class="form_sections">
        <h4><u>Quote Details</u></h4>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group w-100">
              <label>Period of Cover Date</label><br />
              <input
                type="text"
                required
                name="policy_start_date"
                formControlName="policy_start_date"
                placeholder="Cover From"
                class="form-control form-control-sm datepicker"
                matInput
                (focus)="coverFromDatepicker.open()"
                [matDatepicker]="coverFromDatepicker"
                [min]="minInceptionDate"
                [max]="maxInceptionDate"
                (dateChange)="onPolicyStartDateChange($event)"
                [disabled]="isCancellation || isMta"
                [ngClass]="{
                  'is-invalid':
                    (f.policy_start_date.touched || submitted) &&
                    (f.policy_start_date.errors?.required || f.policy_start_date.errors?.inceptionInPast)
                }"
              />
              <mat-datepicker-toggle [for]="coverFromDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #coverFromDatepicker></mat-datepicker>
              <div
                class="invalid-feedback"
                *ngIf="
                  (f.policy_start_date.touched || submitted) &&
                  f.policy_start_date.errors?.required
                "
              >
                Period of Cover Date is required.
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  (f.policy_start_date.touched || submitted) &&
                  f.policy_start_date.errors?.inceptionInPast
                "
              >
                Period of Cover cannot be in the past. Choose today or a future date.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group w-100">
              <label>Period of cover to <span class="text-danger">*</span></label><br />
              <input
                type="text"
                required
                name="period_of_cover_to"
                formControlName="period_of_cover_to"
                placeholder="Cover To"
                class="form-control form-control-sm datepicker"
                matInput
                (focus)="quote_type < 3 ? coverToDatepicker.open() : null"
                [matDatepicker]="coverToDatepicker"
                [ngClass]="{
                  'is-invalid':
                    (f.period_of_cover_to.touched || submitted) &&
                    f.period_of_cover_to.errors?.required
                }"
                readonly
              />
              <mat-datepicker-toggle *ngIf="quote_type < 3" [for]="coverToDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #coverToDatepicker [disabled]="quote_type >= 3"></mat-datepicker>
              <div
                class="invalid-feedback"
                *ngIf="
                  (f.period_of_cover_to.touched || submitted) &&
                  f.period_of_cover_to.errors?.required
                "
              >
                Period of cover to is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="quote_type >= 3">
          <div class="col-md-6">
            <div class="form-group w-100">
              <label>Transaction Type</label>
              <input
                type="text"
                readonly
                class="form-control form-control-sm"
                [value]="transactionTypeLabel"
              />
            </div>
          </div>
          <div class="col-md-6" *ngIf="isMta || isCancellation">
            <label>{{ isMta ? 'Reason for MTA Transaction' : 'Policy Reason' }} <span class="text-danger">*</span></label>
            <mat-form-field style="width: 93%">
              <mat-select
                formControlName="mta_reason_id"
                class="form-control form-control-sm"
                required
                [ngClass]="{
                  'is-invalid':
                    (f.mta_reason_id.touched || submitted) &&
                    f.mta_reason_id.errors?.required
                }"
              >
                <mat-option [value]="">Select Reason</mat-option>
                <mat-option *ngFor="let rsn of policyReasons" [value]="rsn.id">
                  {{ rsn.reasons }}
                </mat-option>
              </mat-select>
              <div
                *ngIf="
                  (f.mta_reason_id.touched || submitted) &&
                  f.mta_reason_id.errors?.required
                "
                class="invalid-feedback"
              >
                Please select a {{ isMta ? 'reason for the MTA transaction' : 'policy reason' }}.
              </div>
            </mat-form-field>
            <div class="form-group w-100 mt-2" *ngIf="reasonIsOther">
              <label>Please specify <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control form-control-sm"
                formControlName="mta_reason_other"
                (blur)="requestAutoSave()"
                [ngClass]="{
                  'is-invalid':
                    (f.mta_reason_other.touched || submitted) &&
                    f.mta_reason_other.errors?.required
                }"
              />
              <div
                *ngIf="
                  (f.mta_reason_other.touched || submitted) &&
                  f.mta_reason_other.errors?.required
                "
                class="invalid-feedback d-block"
              >
                Please enter a reason.
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3" *ngIf="isCancellation && cancellationSubType !== 'standard'">
          <div class="col-md-12">
            <div *ngIf="cancellationSubType === 'ntu'" class="alert alert-info mb-2">
              <strong>NTU (Not Taken Up):</strong> This New Business policy is within 14 days of inception. This cancellation will be logged as an NTU and the cancellation effective date has been set to the original policy start date.
            </div>
            <div *ngIf="cancellationSubType === 'lapsed'" class="alert alert-info mb-2">
              <strong>Lapsed:</strong> This Renewal policy is within 14 days of inception. This cancellation will be logged as Lapsed.
            </div>
          </div>
        </div>
        <div class="row" *ngIf="quote_type >= 3">
          <div class="col-md-6">
            <div class="form-group w-100">
              <label>{{ quote_type == 4 ? 'Cancellation Effective Date' : 'MTA Effective Date' }} <span class="text-danger">*</span></label><br />
              <input
                type="text"
                required
                name="mta_effective_date"
                formControlName="mta_effective_date"
                placeholder="{{ quote_type == 4 ? 'Cancellation Effective Date' : 'MTA Effective Date' }}"
                class="form-control form-control-sm datepicker"
                matInput
                (focus)="openEffectiveDatePicker()"
                [matDatepicker]="effectiveDateDatepicker"
                [min]="effectiveDateMin"
                [max]="effectiveDateMax"
                (dateChange)="onEffectiveDateChange($event)"
                [readonly]="cancellationSubType === 'ntu'"
                [ngClass]="{
                  'is-invalid':
                    (f.mta_effective_date.touched || submitted) &&
                    f.mta_effective_date.errors?.required
                }"
              />
              <mat-datepicker-toggle
                *ngIf="cancellationSubType !== 'ntu'"
                [for]="effectiveDateDatepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #effectiveDateDatepicker
                [disabled]="cancellationSubType === 'ntu'"
              ></mat-datepicker>
              <div
                class="invalid-feedback"
                *ngIf="
                  (f.mta_effective_date.touched || submitted) &&
                  f.mta_effective_date.errors?.required
                "
              >
                {{ quote_type == 4 ? 'Cancellation Effective Date is required.' : 'MTA Effective Date is required.' }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" *ngIf="!isBroker">
            <label><u>Broker</u> <span class="text-danger">*</span></label>
            <mat-form-field style="width: 93%">
              <mat-select
                formControlName="broker_id"
                class="form-control form-control-sm"
                name="broker_id"
                required
                [ngClass]="{
                  'is-invalid':
                    (f.broker_id.touched || submitted) &&
                    f.broker_id.errors?.required
                }"
              >
                <mat-option [value]="">Select Broker</mat-option>
                <mat-option *ngFor="let broker of brokers" [value]="broker.id">
                  {{ broker.name }}
                </mat-option>
              </mat-select>
              <div
                *ngIf="
                  (f.broker_id.touched || submitted) &&
                  f.broker_id.errors?.required
                "
                class="invalid-feedback"
              >
                Broker is required.
              </div>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Proposer Details Section -->
      <div *ngIf="!isCancellation" class="form_sections" formGroupName="proposer_details">
        <h4><u>Proposer Details</u></h4>
        <div class="row">
          <div class="col-md-4" *ngIf="staticData">
            <div class="form-group mt-1`">
              <label>Title <span class="text-danger">*</span></label>
              <mat-select
                formControlName="title"
                class="form-control form-control-sm"
                name="title"
                required
                [ngClass]="{
                  'is-invalid':
                    (proposerControls.title.touched || submitted) &&
                    proposerControls.title.errors?.required
                }"
              >
                <mat-option [value]="">Select Title</mat-option>
                <mat-option *ngFor="let title of titles" [value]="title">
                  {{ title }}
                </mat-option>
              </mat-select>
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.title.touched || submitted) &&
                  proposerControls.title.errors?.required
                "
              >
                Title is required.
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mt-1">
              <label>Proposer Forename(s) <span class="text-danger">*</span></label>
              <input
                type="text"
                name="forename"
                formControlName="forename"
                placeholder="Proposer Forename(s)"
                class="form-control form-control-sm"
                required
                appTitleCase
                (blur)="requestAutoSave()"
                [ngClass]="{
                  'is-invalid':
                    (proposerControls.forename.touched || submitted) &&
                    (proposerControls.forename.errors?.required ||
                      proposerControls.forename.errors?.notCapitalized)
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.forename.touched || submitted) &&
                  proposerControls.forename.errors?.required
                "
              >
                Proposer Forename(s) is required.
              </div>
              <small class="form-text text-white">Please enter the name in full (not just initials) for one individual</small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Proposer Surname <span class="text-danger">*</span></label>
              <input
                type="text"
                name="surname"
                formControlName="surname"
                placeholder="Proposer Surname"
                class="form-control form-control-sm"
                required
                appTitleCase
                (blur)="requestAutoSave()"
                [ngClass]="{
                  'is-invalid':
                    (proposerControls.surname.touched || submitted) &&
                    (proposerControls.surname.errors?.required ||
                      proposerControls.surname.errors?.notCapitalized)
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.surname.touched || submitted) &&
                  proposerControls.surname.errors?.required
                "
              >
                Proposer Surname is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Proposer Date of Birth <span class="text-danger">*</span></label><br />
              <input
                type="text"
                required
                name="date_of_birth"
                formControlName="date_of_birth"
                placeholder="Date of Birth"
                class="form-control form-control-sm datepicker"
                matInput
                (focus)="dobDatepicker.open()"
                [matDatepicker]="dobDatepicker"
                [max]="maxDob"
                (dateChange)="validateDob()"
                [ngClass]="{
                  'is-invalid':
                    (proposerControls.date_of_birth.touched || submitted) &&
                    (proposerControls.date_of_birth.errors?.required ||
                      proposerControls.date_of_birth.errors?.minAge)
                }"
              />
              <mat-datepicker-toggle [for]="dobDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #dobDatepicker></mat-datepicker>
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.date_of_birth.touched || submitted) &&
                  proposerControls.date_of_birth.errors?.required
                "
              >
                Proposer Date of Birth is required.
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.date_of_birth.touched || submitted) &&
                  proposerControls.date_of_birth.errors?.minAge
                "
              >
                Proposer must be at least 18 years old.
              </div>
              <small class="form-text text-white">Ensure you provide accurate data as this is required for sanctions and data protection checks</small>
            </div>
          </div>
        </div>

        <!-- Correspondence Address -->
        <div formGroupName="address">
          <h5 class="mt-3">Correspondence Address</h5>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Correspondence Postcode <span class="text-danger">*</span></label>
                <input
                  type="text"
                  name="postcode"
                  formControlName="postcode"
                  placeholder="Postcode"
                  class="form-control form-control-sm"
                  required
                  (input)="postcodeLookup($event)"
                  (blur)="requestAutoSave()"
                  [matAutocomplete]="auto"
                  #postcodeAutoTrigger="matAutocompleteTrigger"
                  appUpperCase
                  [ngClass]="{
                    'is-invalid':
                      (addressControls.postcode.touched || submitted) &&
                      (addressControls.postcode.errors?.required ||
                        addressControls.postcode.errors?.excludedPostcode)
                  }"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let address of addresses"
                    [value]="addressControls.postcode.value"
                    (click)="onSelectAddress(address)"
                  >
                    {{ address.l || (address.formatted_address ? address.formatted_address.join(', ') : '') }}
                  </mat-option>
                </mat-autocomplete>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (addressControls.postcode.touched || submitted) &&
                    addressControls.postcode.errors?.required
                  "
                >
                  Correspondence Postcode is required.
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (addressControls.postcode.touched || submitted) &&
                    addressControls.postcode.errors?.excludedPostcode
                  "
                >
                  Postcode must be in Great Britain, Northern Ireland or Isle of Man ONLY (not Channel Islands).
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Correspondence Address Line 1 <span class="text-danger">*</span></label>
                <input
                  type="text"
                  name="address1"
                  formControlName="address1"
                  placeholder="Address Line 1"
                  class="form-control form-control-sm"
                  required
                  (blur)="requestAutoSave()"
                  [ngClass]="{
                    'is-invalid':
                      (addressControls.address1.touched || submitted) &&
                      addressControls.address1.errors?.required
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (addressControls.address1.touched || submitted) &&
                    addressControls.address1.errors?.required
                  "
                >
                  Correspondence Address Line 1 is required.
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Correspondence Address Line 2</label>
                <input
                  type="text"
                  name="address2"
                  formControlName="address2"
                  placeholder="Address Line 2"
                  class="form-control form-control-sm"
                  (blur)="requestAutoSave()"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Correspondence Town/County <span class="text-danger">*</span></label>
                <input
                  type="text"
                  name="town_county"
                  formControlName="town_county"
                  placeholder="Town/County"
                  class="form-control form-control-sm"
                  required
                  (blur)="requestAutoSave()"
                  [ngClass]="{
                    'is-invalid':
                      (addressControls.town_county.touched || submitted) &&
                      addressControls.town_county.errors?.required
                  }"
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    (addressControls.town_county.touched || submitted) &&
                    addressControls.town_county.errors?.required
                  "
                >
                  Correspondence Town/County is required.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Contact Details -->
        <div class="row mt-3">
          <div class="col-md-6">
            <div class="form-group">
              <label>Proposer Phone Number <span class="text-danger">*</span></label>
              <input
                type="text"
                name="phone_number"
                formControlName="phone_number"
                placeholder="Phone Number"
                class="form-control form-control-sm"
                required
                appNumbers
                (blur)="requestAutoSave()"
                [ngClass]="{
                  'is-invalid':
                    (proposerControls.phone_number.touched || submitted) &&
                    proposerControls.phone_number.errors?.required
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.phone_number.touched || submitted) &&
                  proposerControls.phone_number.errors?.required
                "
              >
                Proposer Phone Number is required.
              </div>
              <small class="form-text text-white">Please ensure you provide accurate data as this is required for claims processing and data protection checks</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Proposer Email Address <span class="text-danger">*</span></label>
              <input
                type="email"
                name="email_address"
                formControlName="email_address"
                placeholder="Email Address"
                class="form-control form-control-sm"
                required
                (blur)="requestAutoSave()"
                [ngClass]="{
                  'is-invalid':
                    (proposerControls.email_address.touched || submitted) &&
                    (proposerControls.email_address.errors?.required ||
                      proposerControls.email_address.errors?.email)
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.email_address.touched || submitted) &&
                  proposerControls.email_address.errors?.required
                "
              >
                Proposer Email Address is required.
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerControls.email_address.touched || submitted) &&
                  proposerControls.email_address.errors?.email
                "
              >
                Please enter a valid email address.
              </div>
              <small class="form-text text-white">Please ensure you provide accurate data as this is required for claims processing and data protection checks</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Horse Details Section -->
      <div *ngIf="!isCancellation" class="form_sections mt-4" formGroupName="horse_details">
        <h4><u>Horse Details</u></h4>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Stable Name <span class="text-danger">*</span></label>
              <input type="text" name="stable_name" formControlName="stable_name" placeholder="Stable Name" class="form-control form-control-sm" required
                (blur)="requestAutoSave()"
                [ngClass]="{'is-invalid': (horseDetails.get('stable_name').touched || submitted) && (horseDetails.get('stable_name').errors?.required || horseDetails.get('stable_name').errors?.notCapitalized)}" />
              <div class="invalid-feedback" *ngIf="(horseDetails.get('stable_name').touched || submitted) && horseDetails.get('stable_name').errors?.required">Stable Name is required.</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Passport Name <span class="text-danger">*</span></label>
              <input type="text" name="passport_name" formControlName="passport_name" placeholder="Passport Name" class="form-control form-control-sm" required
                (blur)="requestAutoSave()"
                [ngClass]="{'is-invalid': (horseDetails.get('passport_name').touched || submitted) && (horseDetails.get('passport_name').errors?.required || horseDetails.get('passport_name').errors?.notCapitalized)}" />
              <div class="invalid-feedback" *ngIf="(horseDetails.get('passport_name').touched || submitted) && horseDetails.get('passport_name').errors?.required">Passport Name is required.</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Acquired Date <span class="text-danger">*</span></label><br />
              <p>Enter the date the horse was purchased, loaned, leased, gifted or adopted. If the horse is homebred, enter the date of birth.</p>
              <p>Note that the cover start date cannot be before the acquired date, so to select a future acquired date please change the cover start date to enable this.</p>
              <input 
                type="text" 
                required 
                name="acquired_date" 
                formControlName="acquired_date" 
                placeholder="DD/MM/YYYY" 
                class="form-control form-control-sm datepicker" 
                matInput
                (focus)="acquiredDateDatepicker.open()" 
                [matDatepicker]="acquiredDateDatepicker" [max]="maxAcquiredDate"
                [ngClass]="{'is-invalid': (horseDetails.get('acquired_date').touched || submitted) && (horseDetails.get('acquired_date').errors?.required || horseDetails.get('acquired_date').errors?.acquiredAfterCover)}" />
              <mat-datepicker-toggle [for]="acquiredDateDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #acquiredDateDatepicker></mat-datepicker>
              <div class="invalid-feedback" *ngIf="(horseDetails.get('acquired_date').touched || submitted) && horseDetails.get('acquired_date').errors?.required">Acquired Date is required.</div>
              <div class="invalid-feedback" *ngIf="(horseDetails.get('acquired_date').touched || submitted) && horseDetails.get('acquired_date').errors?.acquiredAfterCover">Cover cannot start prior to the date the horse was acquired.</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Ownership Status <span class="text-danger">*</span></label>
              <mat-select formControlName="ownership_status" class="form-control form-control-sm w-100" name="ownership_status" required [ngClass]="{'is-invalid': (horseDetails.get('ownership_status').touched || submitted) && horseDetails.get('ownership_status').errors?.required}">
                <mat-option [value]="">Select Ownership Status</mat-option>
                <mat-option *ngFor="let status of ownershipStatuses" [value]="status.id">{{ status.status_name }}</mat-option>
              </mat-select>
              <div class="invalid-feedback" *ngIf="(horseDetails.get('ownership_status').touched || submitted) && horseDetails.get('ownership_status').errors?.required">Ownership Status is required.</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Purchase Price <span class="text-danger">*</span></label>
              <input 
                type="number" 
                name="purchase_price" 
                formControlName="purchase_price" 
                placeholder="Purchase Price" 
                class="form-control form-control-sm" 
                required 
                min="0" 
                step="1"
                (blur)="requestAutoSave()"
                [ngClass]="{'is-invalid': (horseDetails.get('purchase_price').touched || submitted) && (horseDetails.get('purchase_price').errors?.required || horseDetails.get('purchase_price').errors?.notWholeNumber)}" 
                (wheel)="disableScroll($event)"
                />
              <div class="invalid-feedback" *ngIf="(horseDetails.get('purchase_price').touched || submitted) && horseDetails.get('purchase_price').errors?.required">Purchase Price is required.</div>
              <div class="invalid-feedback" *ngIf="(horseDetails.get('purchase_price').touched || submitted) && horseDetails.get('purchase_price').errors?.notWholeNumber">Must be a whole number in pounds.</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Sum Insured <span class="text-danger" *ngIf="!isAceWithLossOfHorseNo">*</span></label>
              <p *ngIf="!isAceWithLossOfHorseNo">The Sum Insured is the maximum that will be paid in the event of a claim for Loss of Horse and should reflect the horse's current fair market value and not be based on future or potential value. For newly purchased horses, the Sum Insured should not be higher than the purchase price or more than 50% lower than the purchase price.</p>
              <p *ngIf="isAceWithLossOfHorseNo" class="form-text text-muted">For ACE cover with Loss of Horse set to No, Sum Insured is not required and has been set to £0.</p>
              <input type="number" 
                name="sum_insured" 
                formControlName="sum_insured" 
                placeholder="Sum Insured" 
                class="form-control form-control-sm" 
                [required]="!isAceWithLossOfHorseNo"
                min="0" 
                step="1"
                (input)="validateSumInsured()"
                (blur)="requestAutoSave()"
                [readonly]="isAceWithLossOfHorseNo"
                [ngClass]="{'is-invalid': !isAceWithLossOfHorseNo && (horseDetails.get('sum_insured').touched || submitted) && (horseDetails.get('sum_insured').errors?.required || horseDetails.get('sum_insured').errors?.notWholeNumber || horseDetails.get('sum_insured').errors?.sumInsuredExceedsPurchase || horseDetails.get('sum_insured').errors?.sumInsuredTooLow)}" 
                (wheel)="disableScroll($event)"
                />
              <div class="invalid-feedback" *ngIf="!isAceWithLossOfHorseNo && (horseDetails.get('sum_insured').touched || submitted) && horseDetails.get('sum_insured').errors?.required">Sum Insured is required.</div>
              <small class="form-text text-warning d-block" *ngIf="!isAceWithLossOfHorseNo && (horseDetails.get('sum_insured').touched || submitted) && showSumInsuredOver50kReferralMessage">The maximum authorised Sum Insured is £50,000 - higher Sums Insured will require referral before we are able to quote.</small>
              <small class="form-text text-warning d-block" *ngIf="!isAceWithLossOfHorseNo && (horseDetails.get('sum_insured').touched || submitted) && showRestrictedSumInsuredOver20kReferralMessage">Sum Insured over £20,000 with Restricted cover will refer this quote to Underwriters when you submit from Premium Summary.</small>
              <div class="invalid-feedback" *ngIf="!isAceWithLossOfHorseNo && (horseDetails.get('sum_insured').touched || submitted) && horseDetails.get('sum_insured').errors?.sumInsuredExceedsPurchase">The sum insured cannot exceed the purchase price until at least 60 days after the acquired date.</div>
              <div class="invalid-feedback" *ngIf="!isAceWithLossOfHorseNo && (horseDetails.get('sum_insured').touched || submitted) && horseDetails.get('sum_insured').errors?.sumInsuredTooLow">The sum insured cannot be more than 50% lower than the purchase price for a newly purchased horse.</div>
              <div class="invalid-feedback" *ngIf="!isAceWithLossOfHorseNo && (horseDetails.get('sum_insured').touched || submitted) && horseDetails.get('sum_insured').errors?.notWholeNumber">Must be a whole number in pounds.</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Year of Birth <span class="text-danger">*</span></label>
              <mat-select 
                formControlName="horse_birth_year" 
                class="form-control form-control-sm w-100" 
                name="horse_birth_year" 
                required 
                [ngClass]="{'is-invalid': (horseDetails.get('horse_birth_year').touched || submitted) && horseDetails.get('horse_birth_year').errors?.required}">
                <mat-option [value]="">Select Year of Birth</mat-option>
                <mat-option *ngFor="let year of yearsOfBirth" [value]="year">{{ year }}</mat-option>
              </mat-select>
              <div class="invalid-feedback" *ngIf="(horseDetails.get('horse_birth_year').touched || submitted) && horseDetails.get('horse_birth_year').errors?.required">Year of Birth is required.</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Age</label>
              <p>The age is calculated based on 1st January of the year selected</p>
              <input type="text" name="age" formControlName="age" placeholder="Age" class="form-control form-control-sm" readonly />
              <div class="invalid-feedback" *ngIf="(horseDetails.get('age').value === '<1')">Please ensure the foal will be 30 days of age or older when cover starts - there is no cover for foals under 30 days</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cover Type Section -->
      <div *ngIf="!isCancellation" class="form_sections mt-4" formGroupName="policy_cover_details">
        <h4><u>Cover Type</u></h4>
        <div class="row">
          <div class="col-md-12">
            <label>Select Cover Type <span class="text-danger">*</span></label>
            <div class="row mt-3">
              <div class="col-md-4 mb-3" *ngFor="let coverType of coverTypes">
                <div 
                  class="cover-type-box p-3 border rounded" 
                  [ngClass]="{'selected': isCoverTypeSelected(coverType.id), 'disabled': !isCoverTypeAvailable(coverType.id), 'is-invalid': (policyCover.get('cover_type_id').touched || submitted) && policyCover.get('cover_type_id').errors?.required}" 
                  (click)="selectCoverType(coverType.id)" 
                  style="cursor: pointer; min-height: 200px; background-color: #f8f9fa;" 
                  [style.cursor]="isCoverTypeAvailable(coverType.id) ? 'pointer' : 'not-allowed'" 
                  [style.opacity]="isCoverTypeAvailable(coverType.id) ? '1' : '0.5'"
                >
                  <div class="text-center mb-3">
                    <h5>
                      <strong [class.strike-through]="!isCoverTypeAvailable(coverType.id)">{{ coverType.cover_type_name || 'Cover Type' }}</strong>
                    </h5>
                  </div>
                  <input 
                    type="radio" 
                    formControlName="cover_type_id" 
                    [value]="coverType.id" 
                    [disabled]="!isCoverTypeAvailable(coverType.id)" 
                    (click)="$event.stopPropagation()" 
                  />
                  <div class="text-center mt-3" *ngIf="coverType.help_text"><small [class.strike-through]="!isCoverTypeAvailable(coverType.id)" class="form-text">{{ coverType.help_text }}</small></div>
                </div>
              </div>
            </div>
            <div class="invalid-feedback d-block" *ngIf="(policyCover.get('cover_type_id').touched || submitted) && policyCover.get('cover_type_id').errors?.required">Cover Type is required.</div>
          </div>
        </div>
      </div>

      <!-- Use of Horse Section -->
      <div *ngIf="!isCancellation" class="form_sections mt-4" formGroupName="policy_cover_details">
        <h4><u>Use of Horse</u></h4>

        <!-- When Bloodstock cover: dropdown from equine/static-data/class-of-use/{bloodstock_class_id} and cover-types/{type_id}; selected id → bloodstock_id -->
        <div class="row" *ngIf="isBloodstockCover && bloodstockDropdownOptions?.length">
          <div class="col-md-12">
            <label class="font-weight-bold">Horse activities <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="bloodstock_id" [ngClass]="{'is-invalid': (policyCover.get('bloodstock_id').touched || submitted) && !policyCover.get('bloodstock_id').value}">
              <option [ngValue]="null">-- Select --</option>
              <option *ngFor="let opt of bloodstockDropdownOptions" [ngValue]="opt.id">{{ opt.option_name || opt.cover_type_name || opt.name }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="(policyCover.get('bloodstock_id').touched || submitted) && !policyCover.get('bloodstock_id').value">Horse activity is required.</div>
          </div>
        </div>

        <!-- When not Bloodstock: Class of Use and Main Use of Horse -->
        <ng-container *ngIf="!isBloodstockCover">
          <div class="row">
            <div class="col-md-12">
              <p>Please select the Class of Use based on the highest rated activity the horse will be doing, even if this will only be once during the policy year. This should be based on the horse's training level as well as competition level. The Class of Use selected will automatically include any activities in a lower category Class of Use.</p>
              <div class="row mt-3">
                <div class="col-md-6 mb-3" *ngFor="let classData of classes">
                  <div class="class-box p-3 border rounded" [ngClass]="{'selected': isClassSelected(classData.id), 'disabled': !isClassAvailable(classData.class), 'is-invalid': (policyCover.get('class_of_use_id').touched || submitted) && policyCover.get('class_of_use_id').errors?.required}" (click)="selectClass(classData.id)" [style.cursor]="isClassAvailable(classData.class) ? 'pointer' : 'not-allowed'" [style.opacity]="isClassAvailable(classData.class) ? '1' : '0.5'">
                    <div class="text-center text-dark"><h5><strong>{{ classData.class_name }}</strong></h5></div>
                    <input 
                      type="radio" 
                      formControlName="class_of_use_id" 
                      [value]="classData.id" 
                      [disabled]="!isClassAvailable(classData.class)" 
                      (click)="$event.stopPropagation()" 
                    />
                  </div>
                </div>
              </div>
              <div class="invalid-feedback d-block" *ngIf="(policyCover.get('class_of_use_id').touched || submitted) && policyCover.get('class_of_use_id').errors?.required">Class of Use is required.</div>
            </div>
            <!-- Activities for selected class (from API equine/static-data/class-of-use/{class_id}) -->
            <div class="row mt-3" *ngIf="policyCover.get('class_of_use_id').value">
              <div class="col-md-12">
                <div class="p-3 border rounded" style="margin-left: 1rem;">
                  <h5 class="mb-2"><strong>Activities for {{ selectedClass?.class_name }}</strong></h5>
                  <ul class="list-unstyled mb-0" style="font-size: 0.9rem;" *ngIf="classActivitiesForDisplay.length">
                    <li *ngFor="let activity of classActivitiesForDisplay" style="margin-bottom: 4px;">• {{ activity.name || activity.option_name }}</li>
                  </ul>
                  <p *ngIf="!classActivitiesForDisplay.length" class="mb-0 text-muted">No activities available.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-6">
              <label>Main Use of Horse <span class="text-danger">*</span></label>
              <small class="form-text d-block mb-2 text-white">
                Please advise the main activity the horse will be used for/trained for - this does not need to be the highest rated activity i.e. if the horse will only hunt a couple of times but is primarily used for eventing, then 'eventing' should be selected.
              </small>
              <mat-select formControlName="main_use_of_horse_id" class="form-control form-control-sm w-100" name="main_use_of_horse_id" required [ngClass]="{'is-invalid': (policyCover.get('main_use_of_horse_id').touched || submitted) && policyCover.get('main_use_of_horse_id').errors?.required}">
                <mat-option [value]="">Select Main Use</mat-option>
                <mat-option *ngFor="let activity of allActivities" [value]="activity.id">{{ activity.name}}</mat-option>
              </mat-select>
              <div class="invalid-feedback" *ngIf="(policyCover.get('main_use_of_horse_id').touched || submitted) && policyCover.get('main_use_of_horse_id').errors?.required">Main Use of Horse is required.</div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Cover Details Section (only when standard cover selected) -->
      <div class="form_sections cover-details-section mt-4" *ngIf="isStandardCover() && !isCancellation" formGroupName="policy_cover_details">
        <h4><u>Cover Details</u></h4>

        <!-- Loss of Horse (Mandatory for Standard) -->
        <p>Cover for Death, Theft or Straying. All Risks of Mortality i.e. accident, injury, illness, sickness or disease.</p>
        <div class="row mb-3">
          <div class="col-md-12">
            <button type="button" class="btn btn-success w-100 text-left mb-2" disabled>
            Loss of horse
            </button>
          </div>
        </div>

        <!-- Mortality Optional Add-Ons -->
        <h5 class="mt-3">Mortality Optional Add-Ons</h5>
        <div class="row">
          <div class="col-md-6 mb-3">
            <button 
              type="button" 
              class="btn w-100 text-left mb-2" 
              [ngClass]="Number(policyCover.get('is_elective_surgery').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_elective_surgery').setValue(Number(policyCover.get('is_elective_surgery').value) === 1 ? 0 : 1)"
            >
              Non-Emergency Surgery Mortality extension
            </button>
            <small class="form-text text-muted d-block">Cover for death or humane destruction as a result of a non-emergency surgical procedure. Note that this cover can be added if and when required and does not have to be taken out at inception. Once added, there is no premium refund if cover is removed or cancelled (outwith the initial 14 day cooling off period).</small>
          </div>
          <div class="col-md-6 mb-3">
            <button 
              type="button" 
              class="btn w-100 text-left mb-2" 
              [ngClass]="Number(policyCover.get('is_disposal_euthansia').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_disposal_euthansia').setValue(Number(policyCover.get('is_disposal_euthansia').value) === 1 ? 0 : 1)"
              >
              Euthanasia and Disposal Charges extension
            </button>
            <small class="form-text text-muted d-block">Provides cover up to £400 towards the cost of euthanasia and disposal charges in conjunction with a covered claim for death of the horse.</small>
          </div>
        </div>

        <!-- Permanent Loss of Use -->
        <h5 class="mt-4">Do you want to add cover for Permanent Loss of Use?</h5>
        <p class="form-text text-muted">Permanent Loss of Use or Economic Destruction - cover if the horse becomes permanently and totally incapable of fulfilling the purpose for which it is kept, and as a result is destroyed or kept in retirement. Cover is up to 75% of the FMV/SI if the horse is destroyed, or up to 60% of the FMV/SI if the horse is kept in retirement.</p>
        <div class="row mb-2">
          <div class="col-md-12">
            <button 
              type="button" 
              class="btn mr-2" 
              [ngClass]="Number(policyCover.get('is_cover_for_permanent_lou').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              [disabled]="isLOUNoLocked()" 
              (click)="onPermanentLouSelect(1)"
            >
              Yes
            </button>
            <button 
              type="button" 
              class="btn" 
              [ngClass]="Number(policyCover.get('is_cover_for_permanent_lou').value) !== 1 ? 'btn-success' : 'btn-outline-secondary'" 
              [disabled]="isLOUNoLocked()" 
              (click)="onPermanentLouSelect(0)"
            >
              No
            </button>
          </div>
        </div>
        <p class="small text-muted mt-2 mb-0" *ngIf="!isLOUEligible()">This cover can only be offered for horses aged 4 years - 12 years and on Class of Use 2, 3 or 4</p>

        <div class="row mt-3" *ngIf="Number(policyCover.get('is_cover_for_permanent_lou').value) === 1">
          <div class="col-md-6">
            <label>LOU Activity? <span class="text-danger">*</span></label>
            <mat-select formControlName="lou_activity_id" class="form-control form-control-sm w-100" placeholder="Select LOU Activity"
              [ngClass]="{'is-invalid': (policyCover.get('lou_activity_id').touched || submitted) && policyCover.get('lou_activity_id').errors?.required}"
              (selectionChange)="requestPremiumUpdate()">
              <mat-option [value]="">Select LOU Activity</mat-option>
              <mat-option *ngFor="let a of louActivities" [value]="a.id">{{ a.name }}</mat-option>
            </mat-select>
            <div class="invalid-feedback" *ngIf="(policyCover.get('lou_activity_id').touched || submitted) && policyCover.get('lou_activity_id').errors?.required">LOU Activity is required.</div>
            <div class="mt-2" *ngIf="louActivityIsOther">
              <label>Please specify (this will trigger an automatic referral) <span class="text-danger">*</span></label>
              <input
                type="text"
                formControlName="lou_other_specify"
                class="form-control form-control-sm"
                placeholder="Enter details"
                (blur)="requestAutoSave()"
                [ngClass]="{
                  'is-invalid':
                    (policyCover.get('lou_other_specify').touched || submitted) &&
                    policyCover.get('lou_other_specify').errors?.required
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (policyCover.get('lou_other_specify').touched || submitted) &&
                  policyCover.get('lou_other_specify').errors?.required
                "
              >
                Please specify the LOU activity.
              </div>
            </div>
            <p class="text-warning small mt-1" *ngIf="requiresLouReferral">This selection will trigger an automatic referral at the end stage of the quote.</p>
          </div>
        </div>

        <!-- Veterinary Fees -->
        <h5 class="mt-4">Do you want to add cover for Veterinary Fees?</h5>
        <div class="row mb-2">
          <div class="col-md-12">
            <button 
              type="button" 
              class="btn mr-2" 
              [ngClass]="Number(policyCover.get('is_vet_fee_selected').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_vet_fee_selected').setValue(1)"
            >
              Yes
            </button>
            <button 
              type="button" 
              class="btn" 
              [ngClass]="policyCover.get('is_vet_fee_selected').value !== 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_vet_fee_selected').setValue(0)"
            >
              No
            </button>
          </div>
        </div>

        <div *ngIf="Number(policyCover.get('is_vet_fee_selected').value) === 1">
          <h5 class="mt-3">Please select Enhanced or Essential cover</h5>
          <p class="form-text text-warning" *ngIf="isVetFeeEnhancedLocked">Because LOU cover has been selected, only Enhanced cover is available</p>
          <div class="row mt-3">
            <div class="col-md-6 mb-3">
              <div 
                class="cover-type-box p-3 border rounded" 
                [ngClass]="{'selected': Number(policyCover.get('vet_fee_cover_type').value) === 1, 'disabled': false}" 
                (click)="onVetFeeCoverTypeChange(1)"
                style="cursor: pointer; min-height: 200px; background-color: #f8f9fa;"
                [style.cursor]="'pointer'"
              >
                <div class="text-center mb-2"><h5><strong>Enhanced</strong></h5></div>
                <small class="form-text d-block">
                  Veterinary Fees cover starting at £3000 per incident up to £7500 per incident with various fixed excess options and voluntary co-insurance.<br><br>
                  Associated Treatment included as standard up to £750 within incident limit.<br><br>
                  15% mandatory co-insurance for EGUS claims.
                </small>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div 
                class="cover-type-box p-3 border rounded" 
                [ngClass]="{'selected': Number(policyCover.get('vet_fee_cover_type').value) === 2, 'disabled': isVetFeeEnhancedLocked}" 
                (click)="onVetFeeCoverTypeChange(2)"
                style="cursor: pointer; min-height: 200px; background-color: #f8f9fa;"
                [style.cursor]="isVetFeeEnhancedLocked ? 'not-allowed' : 'pointer'"
                [style.opacity]="isVetFeeEnhancedLocked ? '0.5' : '1'"
              >
                <div class="text-center mb-2"><h5><strong>Essential</strong></h5></div>
                <small class="form-text d-block">
                  Veterinary Fees cover at £5500 per annum with various excess options.<br><br>
                  No cover for Associated Treatment.<br><br>
                  15% mandatory co-insurance for EGUS claims.<br><br>
                  £1000 sub-limit for mouth, oral or dental disorders.<br><br>
                  £1000 sub-limit for advanced diagnostic imaging.
                </small>
              </div>
            </div>
          </div>

          <!-- Enhanced VF options (vet_fee_cover_type === 1) -->
          <div *ngIf="Number(policyCover.get('vet_fee_cover_type').value) === 1">
            <h5 class="mt-3">Please select your Veterinary Fees option</h5>
            <div class="row mb-2">
              <div class="col-md-12">
                <button 
                  type="button" 
                  class="btn mr-2 mb-2" 
                  *ngFor="let opt of vfEnhancedOptions" 
                  [ngClass]="policyCover.get('vet_fee_id').value === opt.id ? 'btn-success' : 'btn-outline-secondary'" 
                  [class.strike-through]="!isVfOptionAvailable(opt)"
                  [disabled]="!isVfOptionAvailable(opt)" 
                  (click)="policyCover.get('vet_fee_id').setValue(opt.id)"
                >
                  {{ opt.label }}
                </button>
              </div>
              <p style="padding: 0px 15px;" *ngIf="!isVfOptionAvailable(vfEnhancedOptions[2])">The ‘£6000 per incident’ option is only available if the horse is under 20 years old</p>
              <p style="padding: 0px 15px;" *ngIf="!isVfOptionAvailable(vfEnhancedOptions[3])">The ‘£7500 per incident’ option is only available if the horse is under 20 years old and the Sum Insured is >£5000</p>
            </div>
            <h5 class="mt-3">Please select your fixed excess</h5>
            <p class="form-text text-muted">This amount must be covered by the customer before any claim will be payable, and will apply in respect of each separate incident claimed. Note that if the £150 option is selected then the co-insurance must be 20% or higher.</p>
            <div class="row mb-2">
              <div class="col-md-12">
                <button 
                  type="button" 
                  class="btn mr-2 mb-2" 
                  *ngFor="let opt of vfFixedExcessOptions" 
                  [ngClass]="policyCover.get('vet_fee_excess_id').value === opt.id ? 'btn-success' : 'btn-outline-secondary'" 
                  (click)="onVetFeeExcessSelect(opt.id)"
                >
                  {{ opt.label }}
                </button>
              </div>
            </div>
            <h5 class="mt-3">Please select your co-insurance</h5>
            <p class="form-text text-warning" *ngIf="is150ExcessSelected">The co-insurance must be 20% or higher with the excess option selected</p>
            <p class="form-text text-muted">This is the amount expressed as a percentage of each claim which the customer will be required to pay in addition to the excess. The co-insurance is calculated after the fixed monetary excess has been deducted.</p>
            <div class="row mb-2">
              <div class="col-md-12">
                <button 
                  type="button" 
                  class="btn mr-2 mb-2" 
                  *ngFor="let opt of vfCoInsuranceOptions" 
                  [ngClass]="policyCover.get('vet_fee_co_insurance_id').value === opt.id ? 'btn-success' : 'btn-outline-secondary'" 
                  [disabled]="isCoInsuranceDisabled(opt)" 
                  (click)="onVetFeeCoInsuranceSelect(opt.id)"
                >
                  {{ opt.label }}
                </button>
              </div>
            </div>
          </div>

          <!-- Essential VF  (vet_fee_cover_type === 2) -->
          <div *ngIf="Number(policyCover.get('vet_fee_cover_type').value) === 2">
            <h5 class="mt-3">Veterinary Fees option</h5>
            <p class="form-text text-muted">Cover is per incident and in aggregate, which means £5500 is the total benefit per policy period</p>
            <div class="row mb-2">
              <div class="col-md-12">
                <button type="button" class="btn btn-success" disabled>£5500 per annum</button>
              </div>
            </div>
          </div>
          <!-- Only show for essential cover -->

          <div *ngIf="Number(policyCover.get('vet_fee_cover_type').value) === 2">
            <h5 class="mt-3">Please select your excess</h5>
            <p class="form-text text-muted">The monetary amount must be covered by the customer before any claim will be payable. The amount expressed as a percentage is the co-insurance which the customer will be required to pay in addition to the excess. The co-insurance is calculated after the fixed monetary excess has been deducted. The option selected will apply in respect of each separate incident claimed.</p>
            <div class="row mb-2">
              <div class="col-md-12">
                <button 
                  type="button" 
                  class="btn mr-2 mb-2" 
                  *ngFor="let opt of vfEssentialExcessOptions" 
                  [ngClass]="policyCover.get('vet_fee_excess_id').value === opt.id ? 'btn-success' : 'btn-outline-secondary'" 
                  (click)="onVetFeeExcessSelect(opt.id)"
                >
                  {{ opt.label }}
                </button>
              </div>
            </div>
          </div>

          <!-- Veterinary Fees Optional Add-Ons -->
          <h5 class="mt-4">Veterinary Fees Optional Add-Ons</h5>
          <div class="row">
            <div class="col-md-6 mb-3">
              <button 
                type="button" 
                class="btn w-100 text-left mb-2" 
                [ngClass]="Number(policyCover.get('is_livery_hispitalization').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
                (click)="policyCover.get('is_livery_hispitalization').setValue(Number(policyCover.get('is_livery_hispitalization').value) === 1 ? 0 : 1)"
              >
                Hospitalisation and Transportation extension
              </button>
              <small class="form-text text-muted d-block">Provides cover up to £400 per annum towards the cost of livery whilst an in-patient at an equine hospital or towards emergency transportation costs to a veterinary hospital</small>
            </div>
            <div class="col-md-6 mb-3">
              <button 
                type="button" 
                class="btn w-100 text-left mb-2" 
                [ngClass]="Number(policyCover.get('is_life_saving_surgery_selected').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
                [disabled]="isLifeSavingFree" 
                (click)="onLifeSavingSurgeryToggle()"
              >
                Life-Saving Surgery Increased Benefit extension
              </button>
              <p class="form-text text-success" *ngIf="isLifeSavingFree">This cover has been included free of charge due to the horse's Sum Insured</p>
              <small class="form-text text-muted d-block">Additional cover for emergency surgical procedures up to £2500 per policy period - this benefit will be combined with the benefit selected for Veterinary Fees in the event of the horse requiring life-saving surgery</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Cover Details for Restricted cover -->
      <div class="form_sections cover-details-section mt-4" *ngIf="isRestrictedCover && !isCancellation" formGroupName="policy_cover_details">
        <h4><u>Cover Details</u></h4>

        <!-- Loss of Horse (Mandatory for Restricted) -->
        <h5 class="mt-3">Cover for Death, Theft or Straying. All cover is restricted to Accidental External Injury Only i.e. there is no cover for illness, sickness or disease.</h5>
        <div class="row mb-3">
          <div class="col-md-12">
            <button type="button" class="btn btn-success w-100 text-left mb-2" disabled>
              Loss of horse
            </button>
          </div>
        </div>

        <!-- Mortality Optional Add-Ons -->
        <h5 class="mt-3">Mortality Optional Add-Ons</h5>
        <div class="row">
          <div class="col-md-6 mb-3">
            <button 
              type="button" 
              class="btn w-100 text-left mb-2" 
              [ngClass]="Number(policyCover.get('is_disposal_euthansia').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_disposal_euthansia').setValue(Number(policyCover.get('is_disposal_euthansia').value) === 1 ? 0 : 1)"
            >
              Euthanasia and Disposal Charges extension
            </button>
            <small class="form-text text-muted d-block">Provides cover up to £400 towards the cost of euthanasia and disposal charges in conjunction with a covered claim for death of the horse.</small>
          </div>
        </div>

        <!-- Veterinary Fees -->
        <h5 class="mt-4">Do you want to add cover for Veterinary Fees?</h5>
        <div class="row mb-2">
          <div class="col-md-12">
            <button 
              type="button" 
              class="btn mr-2" 
              [ngClass]="Number(policyCover.get('is_vet_fee_selected').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_vet_fee_selected').setValue(1)"
            >
              Yes
            </button>
            <button 
              type="button" 
              class="btn" 
              [ngClass]="policyCover.get('is_vet_fee_selected').value !== 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_vet_fee_selected').setValue(0)"
            >
              No
            </button>
          </div>
        </div>

        <div *ngIf="Number(policyCover.get('is_vet_fee_selected').value) === 1">
          <div class="row mb-2">
            <div class="col-md-12">
              <button 
                type="button" 
                class="btn mr-2 mb-2" 
                *ngFor="let opt of vfRestrictedCoverOptions" 
                [ngClass]="policyCover.get('vet_fee_id').value === opt.id ? 'btn-success' : 'btn-outline-secondary'" 
                (click)="policyCover.get('vet_fee_id').setValue(policyCover.get('vet_fee_id').value === opt.id ? null : opt.id)"
              >
                {{ opt.label }}
              </button>
            </div>
          </div>
          <small class="form-text text-muted d-block mb-3">{{ vfRestrictedCoverHelpText }}</small>

          <h5 class="mt-3">Please select your excess</h5>
          <p class="form-text text-muted">This amount must be covered by the customer before any claim will be payable, and will apply in respect of each separate incident claimed.</p>
          <div class="row mb-2">
            <div class="col-md-12">
              <button 
                type="button" 
                class="btn mr-2 mb-2" 
                *ngFor="let opt of vfRestrictedExcessOptions" 
                [ngClass]="policyCover.get('vet_fee_excess_id').value === opt.id ? 'btn-success' : 'btn-outline-secondary'" 
                (click)="policyCover.get('vet_fee_excess_id').setValue(opt.id)"
              >
                {{ opt.label }}
              </button>
            </div>
          </div>

          <!-- Veterinary Fees Optional Add-Ons -->
          <h5 class="mt-4">Veterinary Fees Optional Add-Ons</h5>
          <div class="row">
            <div class="col-md-6 mb-3">
              <button 
                type="button" 
                class="btn w-100 text-left mb-2" 
                [ngClass]="Number(policyCover.get('is_livery_hispitalization').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
                (click)="policyCover.get('is_livery_hispitalization').setValue(Number(policyCover.get('is_livery_hispitalization').value) === 1 ? 0 : 1)"
              >
                Hospitalisation and Transportation extension
              </button>
              <small class="form-text text-muted d-block">Provides cover up to £400 per annum towards the cost of livery whilst an in-patient at an equine hospital or towards emergency transportation costs to a veterinary hospital</small>
            </div>
            <div class="col-md-6 mb-3">
              <button 
                type="button" 
                class="btn w-100 text-left mb-2" 
                [ngClass]="Number(policyCover.get('is_life_saving_surgery_selected').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
                (click)="onLifeSavingSurgeryToggle()"
              >
                Life-Saving Surgery Increased Benefit extension
              </button>
              <small class="form-text text-muted d-block">Additional cover for emergency surgical procedures up to £2500 per policy period - this benefit will be combined with the benefit selected for Veterinary Fees in the event of the horse requiring life-saving surgery</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Cover Details for ACE Cover -->
      <div class="form_sections cover-details-section mt-4" *ngIf="isACECover && !isCancellation" formGroupName="policy_cover_details">
        <h4><u>Cover Details</u></h4>
       
        <h5 class="mt-3">Veterinary Fees cover for Accident, Colic and Emergency surgery (as a result of an accident or colic) only. Cover is per incident and in aggregate, which means the amount selected is the total benefit per policy period. Non-surgical colic carries an additional £500 excess.</h5>
        <div class="row">
          <div class="col-md-6 mb-3">
            <button type="button" class="btn btn-success w-100 text-left mb-2" disabled>
              Veterinary Fees - £7500 per annum, £350 excess
            </button>
          </div>  
        </div>

        <!-- Veterinary Fees Optional Add-Ons -->
        <h5 class="mt-3">Veterinary Fees Optional Add-Ons</h5>
        <div class="row">
          <div class="col-md-6 mb-3">
            <button 
              type="button" 
              class="btn w-100 text-left mb-2" 
              [ngClass]="Number(policyCover.get('is_livery_hispitalization').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_livery_hispitalization').setValue(Number(policyCover.get('is_livery_hispitalization').value) === 1 ? 0 : 1)"
            >
              Hospitalisation and Transportation extension
            </button>
            <small class="form-text text-muted d-block">Provides cover up to £400 per annum towards the cost of livery whilst an in-patient at an equine hospital or towards emergency transportation costs to a veterinary hospital</small>
          </div>
        </div>

        <!-- Loss of Horse -->
        <h5 class="mt-4">Do you want to add cover for Loss of Horse?</h5>
        <p class="form-text text-muted">Cover for Death, Theft or Straying. All Risks of Mortality i.e. accident, injury, illness, sickness or disease.</p>
        <div class="row mb-2">
          <div class="col-md-12">
            <button 
              type="button" 
              class="btn mr-2" 
              [ngClass]="Number(policyCover.get('is_loss_of_horse_selected').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_loss_of_horse_selected').setValue(1)"
            >
              Yes
            </button>
            <button 
              type="button" 
              class="btn" 
              [ngClass]="Number(policyCover.get('is_loss_of_horse_selected').value) === 2 ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="policyCover.get('is_loss_of_horse_selected').setValue(2)"
            >
              No
            </button>
            <div class="text-danger small mt-1" *ngIf="submitted && policyCover.get('is_loss_of_horse_selected').errors?.required">
              Please select whether you want cover for Loss of Horse.
            </div>
          </div>
        </div>

        <!-- Mortality Optional Add-Ons (when Loss of Horse = Yes) -->
        <div *ngIf="Number(policyCover.get('is_loss_of_horse_selected').value) === 1">
          <h5 class="mt-4">Mortality Optional Add-Ons</h5>
          <div class="row">
            <div class="col-md-6 mb-3">
              <button 
                type="button" 
                class="btn w-100 text-left mb-2" 
                [ngClass]="Number(policyCover.get('is_elective_surgery').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
                (click)="policyCover.get('is_elective_surgery').setValue(Number(policyCover.get('is_elective_surgery').value) === 1 ? 0 : 1)"
              >
                Non-Emergency Surgery Mortality extension
              </button>
              <small class="form-text text-muted d-block">Cover for death or humane destruction as a result of a non-emergency surgical procedure. Note that this cover can be added if and when required and does not have to be taken out at inception. Once added, there is no premium refund if cover is removed or cancelled (outwith the initial 14 day cooling off period).</small>
            </div>
            <div class="col-md-6 mb-3">
              <button 
                type="button" 
                class="btn w-100 text-left mb-2" 
                [ngClass]="Number(policyCover.get('is_disposal_euthansia').value) === 1 ? 'btn-success' : 'btn-outline-secondary'" 
                (click)="policyCover.get('is_disposal_euthansia').setValue(Number(policyCover.get('is_disposal_euthansia').value) === 1 ? 0 : 1)"
              >
                Euthanasia and Disposal Charges extension
              </button>
              <small class="form-text text-muted d-block">Provides cover up to £400 towards the cost of euthanasia and disposal charges in conjunction with a covered claim for death of the horse.</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Cover Details for Bloodstock cover -->
      <div class="form_sections cover-details-section mt-4" *ngIf="isBloodstockCover && !isCancellation" formGroupName="policy_cover_details">
        <h4><u>Cover Details</u></h4>

        <!-- Loss of Horse -->
        <p>Cover for Death, Theft or Straying. All Risks of Mortality i.e. accident, injury, illness, sickness or disease.</p>
        <div class="row mb-3">
          <div class="col-md-12">
            <button type="button" class="btn btn-success w-100 text-left mb-2" disabled>
            Loss of horse
            </button>
          </div>
        </div>

        <h5 class="mt-4">Would you like to add cover for Life-Saving Surgery Veterinary Fees? (£7500 per annum, £350 excess)</h5>
        <small class="form-text text-muted mb-4">Cover is for life-saving surgery/colic surgery ONLY. Cover is per incident and in aggregate, which means the amount selected is the total benefit per policy period.</small>
        <div class="row mb-2">
          <div class="col-md-12">
            <button 
              type="button" 
              class="btn mr-2" 
              [ngClass]="bloodstockLssSelected ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="onBloodstockLssToggle(true)"
            >
              Yes
            </button>
            <button 
              type="button" 
              class="btn" 
              [ngClass]="!bloodstockLssSelected ? 'btn-success' : 'btn-outline-secondary'" 
              (click)="onBloodstockLssToggle(false)"
            >
              No
            </button>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="row mt-4">
        <div class="col-md-12 text-right">
          <button *ngIf="quote_type < 3" type="submit" class="btn btn-success btn-sm" [disabled]="saving">Save & Continue</button>
          <button *ngIf="quote_type == 3" type="submit" class="btn btn-success btn-sm">Proceed with MTA</button>
          <button *ngIf="quote_type == 4 && cancellationSubType === 'ntu'" type="submit" class="btn btn-danger btn-sm">Process NTU</button>
          <button *ngIf="quote_type == 4 && cancellationSubType === 'lapsed'" type="submit" class="btn btn-danger btn-sm">Process Lapsed</button>
          <button *ngIf="quote_type == 4 && cancellationSubType === 'standard'" type="submit" class="btn btn-danger btn-sm">Cancel Policy</button>
        </div>
      </div>
    </div>
    <div class="col-md-4 equine-calculations-col">
      <app-equine-calculations class="equine-calculations-sticky" [quoteInfo]="modelObject"></app-equine-calculations>
    </div>
  </div>
</form>

<!-- ACE cover: Loss of Horse No – Sum Insured not required popup -->
<ng-template #aceNoSumInsuredModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Sum Insured not required (ACE cover)</h5>
    <button type="button" class="close" aria-label="Close" (click)="dismissAceNoSumInsuredModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="mb-0">Because Loss of Horse is set to <strong>No</strong> for ACE cover, you do not have to specify a Sum Insured. It has been set to £0.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="dismissAceNoSumInsuredModal()">OK</button>
  </div>
</ng-template>
 